// src/context/SettingsContext.js
import React, { createContext, useContext, useState, useEffect } from 'react';
import api from '../utils/api';

const SettingsContext = createContext({
  businessName: 'Snooker Club',
  businessTagline: 'Management System',
  logoUrl: '',
  reload: () => {},
});

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState({
    businessName: localStorage.getItem('biz_name') || 'Snooker Club',
    businessTagline: localStorage.getItem('biz_tagline') || 'Management System',
    logoUrl: localStorage.getItem('biz_logo') || '',
  });

  const load = async () => {
    try {
      const res = await api.get('/settings');
      const s = res.data;
      const next = {
        businessName:    s.business_name    || 'Snooker Club',
        businessTagline: s.business_tagline || 'Management System',
        logoUrl:         s.logo_url         || '',
      };
      setSettings(next);
      localStorage.setItem('biz_name',    next.businessName);
      localStorage.setItem('biz_tagline', next.businessTagline);
      localStorage.setItem('biz_logo',    next.logoUrl);
    } catch (_) {}
  };

  useEffect(() => { load(); }, []);

  return (
    <SettingsContext.Provider value={{ ...settings, reload: load }}>
      {children}
    </SettingsContext.Provider>
  );
}

export const useSettings = () => useContext(SettingsContext);
